<template>
	<footer
		class="footer"
		style="background-color: transparent; padding: 0rem 0 !important"
	>
		<!-- <div class="container container-lg">
            <div class="row">
                <div class="col-md-6 mb-5 mb-md-0">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/landing" title="Landing Page">
                            <img v-lazy="'img/theme/landing.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-6 mb-5 mb-lg-0">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/profile" title="Profile Page">
                            <img v-lazy="'img/theme/profile.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
            </div>
        </div> -->
		<div class="container">
			<!-- <div class="row row-grid align-items-center my-md"> -->
			<!-- <div class="col-lg-12">
                    <h5 class="text-primary font-weight-light mb-2">Meningkatkan Penatausahaan Pengelolaan Keuangan dan Pelayanan Pajak yang Transparan dan Akuntabel berbasis Teknologi Informasi.</h5>
                    <h6 class="mb-0 font-weight-light">Terwujudnya Pengelolaan Keuangan dan Pelayanan Pajak Yang Profesional, Berteknologi dan Handal.</h6>
                </div> -->
			<!-- <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener" href="https://twitter.com/creativetim"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.facebook.com/creativetim"
                       class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-facebook-square"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://dribbble.com/creativetim"
                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-dribbble"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://github.com/creativetimofficial"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Star on Github">
                        <i class="fa fa-github"></i>
                    </a>
                </div> -->
			<!-- </div> -->
			<!-- <hr> -->
			<br />
			<div class="row align-items-center justify-content-md-between text-black">
				<div class="col-md-12">
					<div class="copyright text-center">
						&copy; {{ year }} E-BPHTB PEMERINTAH KOTA TARAKAN
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>
<script>
	export default {
		name: "app-footer",
		data() {
			return {
				year: new Date().getFullYear(),
			}
		},
	}
</script>
<style></style>
